import { useMask } from '@react-input/mask'
import type { Ref } from 'react'
import type { DocsFormValues } from '@/helpers/docs-form'

export const useDocsFormMasks = () => {
  const contractDateRef = useMask({
    mask: '__.__.____',
    replacement: { _: /\d/ },
  })

  const birthDateRef = useMask({
    mask: '__.__.____',
    replacement: { _: /\d/ },
  })

  const passportSeriesNumberRef = useMask({
    mask: '__ __ ______',
    replacement: { _: /\d/ },
  })

  const passportIssueDateRef = useMask({
    mask: '__.__.____',
    replacement: { _: /\d/ },
  })

  const invoiceDateRef = useMask({
    mask: '__.__.____',
    replacement: { _: /\d/ },
  })

  const passportDivisionCodeRef = useMask({
    mask: '___-___',
    replacement: { _: /\d/ },
  })

  const reportSignedDateRef = useMask({
    mask: '__.__.____',
    replacement: { _: /\d/ },
  })

  return {
    contractDate: contractDateRef,
    birthDate: birthDateRef,
    passportSeriesNumber: passportSeriesNumberRef,
    passportIssueDate: passportIssueDateRef,
    passportDivisionCode: passportDivisionCodeRef,
    invoiceDate: invoiceDateRef,
    reportSignedDate: reportSignedDateRef,
  } satisfies Partial<Record<keyof DocsFormValues, Ref<HTMLInputElement>>>
}
